// This is the Task list that uses a Task to create a list of tasks and render them

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "react-router-dom";

//CONNECTING REDUX STORE -> dynamic content reload across site
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// FETCH ACTION TYPES
import * as taskActions from '../actions/task-actions';

// LOAD COMPONENTS
import Task from '../components/task.jsx';



class ShoppingList extends Component {
  constructor(props) {
	 	super(props);
    this.state = {
       test: 'gg'
     };

     //TODO: create bind event fro listening to input boxes to cahnge the state value on text inputted
  }

  addTask() {
    var itemTitle = document.getElementById("title").value;
    document.getElementById("title").value = "";
    var itemDesc = document.getElementById("description").value;
    document.getElementById("description").value = "";

    if (itemTitle != "") {
      let task = {
        title: itemTitle,
        description: itemDesc
      }
      // trigger action addTask
      this.props.actions.addTask(task)
    }
  }

  removeTask(index, self) {
    //modify data from component
    self.setState({test:"tt"})

    //TRIGGER action removeTask
    self.props.actions.removeTask(index)
  }

  render() {
    // Loops through this.props.tasks passed from task-reducers
    // returns Task component with passed in variables and a reference to removeTask function
		let tasks = this.props.tasks.map((obj, index) => {
			return (
        <Task task={obj} key={index} index={index} onRemoveTask={this.removeTask} self={this} />
			)
		 });

    return (
        <div className="shopping-list">
          <h1>Shopping List for {this.props.name}</h1>
          <input type="text" id="title" placeholder="Task title"/>
          <input type="text" id="description" placeholder="Task desc"/>
          <button type="button" onClick={() => this.addTask()}>Add</button>

          <ul>
            {tasks}
          </ul>
        </div>

    );
  }
}

//CONNECT REDUX FETCH APP STATE
function mapStateToProps(state, props) {
  return {
    tasks: state.tasks
  };
}

//CONNECT REDUX TRIGGER ACTION TO CHANGE APP STATE
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(taskActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingList);



// WEBPACK FOOTER //
// ./client/containers/tasklist.jsx